import { QueryCache, QueryClient } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";

import { handleError } from "./utilities/errors";

/**
 * The app's single QueryClient.
 *
 * Lives in its own module rather than in `index.tsx` on purpose. It used to be
 * exported from the entry point, and `FulcrumAdapter` imported it from there —
 * which meant importing any adapter pulled in the entry point, and the entry
 * point calls `ReactDOM.createRoot(document.getElementById("root"))` at module
 * scope. Under jest there is no `#root`, so four unrelated suites (contexts,
 * media adapters, data-source adapters, AppContent) threw on import and never
 * ran a single test.
 *
 * Keep it free of anything that mounts or renders.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // disable query retries when failed
      retry: false,
      refetchOnWindowFocus: false
    }
  },
  queryCache: new QueryCache({
    onError(error) {
      const appError = handleError(error);
      // Log to Sentry or show a notification
      enqueueSnackbar(appError.message, { variant: "error" });
    }
  })
});
